// extracted by mini-css-extract-plugin
export var drawer = "HeaderSimple-module--drawer--804a3";
export var header = "HeaderSimple-module--header--f31a0";
export var inner = "HeaderSimple-module--inner--d20c0";
export var link = "HeaderSimple-module--link--78c03";
export var linkdrawer = "HeaderSimple-module--linkdrawer--e8a2f";